import React, { useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../store/AuthContext";
import { useEdges } from "reactflow";
import { checkStatus } from "../services/userService";

const PrivateRoute = ({ component: Component, ...rest }) => {
	const { loading, authenticated, logOut } = useContext(AuthContext);
	let location = useLocation();

	if (loading) {
		return "";
	}

	if (!authenticated) {
		// user is not authenticated
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	return <Component {...rest} />;
};

export default PrivateRoute;
